import { createFeatureSelector, createSelector } from '@ngrx/store'
import { selectIsRapUser, selectModeConfiguration } from '../auth/auth.selectors'
import { VendorConfigurationMode } from '../auth/mode-configuration.types'
import { selectActivePaceSetterCode } from '../issue/issue.selectors'
import { PaceSetterCode } from '../issue/issue.types'
import { selectBreakdownLocationDetails, selectLocationClub } from '../location/location.selectors'
import { BreakdownLocationDetails } from '../location/location.types'
import { selectMemberActiveVehicle } from '../member/member.selectors'
import { Vehicle } from '../member/member.types'
import { selectAppointmentSchedulingConfig } from '../servicing-club/servicing-club.selectors'
import { AppointmentSchedulingConfig } from '../servicing-club/servicing-club.types'
import { ABTestsState } from '../ui/ui.reducer'
import { selectAbTestState } from '../ui/ui.selectors'
import { ABTestParams } from '../ui/ui.types'
import { Appointment, AppointmentAvailability, AppointmentState } from './appointment.types'

const stateKey = 'appointment'

export const selectAppointmentState = createFeatureSelector<AppointmentState>(stateKey)

export const selectAppointmentAvailabilityCache = createSelector(
  selectAppointmentState,
  (state: AppointmentState) => state.appointmentAvailabilityCache || {}
)

export const selectAppointmentAvailability = createSelector(
  selectLocationClub,
  selectAppointmentAvailabilityCache,
  (club, cache): AppointmentAvailability | null => cache[club] || null
)

export const selectSelectedAppointment = createSelector(
  selectAppointmentState,
  (state: AppointmentState): Appointment | null => state?.selectedAppointment || null
)

export const selectAppointmentEnabled = createSelector(
  selectAbTestState,
  selectModeConfiguration,
  selectIsRapUser,
  selectAppointmentSchedulingConfig,
  selectActivePaceSetterCode,
  selectMemberActiveVehicle,
  selectBreakdownLocationDetails,
  (
    abTestsState: ABTestsState,
    rapConfig: VendorConfigurationMode,
    isRapUser: boolean,
    appointmentSchedulingConfig: AppointmentSchedulingConfig | null,
    paceSetterCode: PaceSetterCode | null,
    activeVehicle: Vehicle | null,
    breakdownLocationDetails: BreakdownLocationDetails,
  ): boolean =>
    abTestsState[ABTestParams.APPOINTMENT_SCHEDULING] &&
    Boolean(appointmentSchedulingConfig) &&
    Boolean(paceSetterCode) &&
    appointmentSchedulingConfig.enabled &&
    (!isRapUser || rapConfig.appointmentSchedulingEnabled) &&
    appointmentSchedulingConfig.issueTypes.includes(paceSetterCode.issueType) &&
    (!activeVehicle?.duty || appointmentSchedulingConfig.vehicleDuty.includes(activeVehicle.duty)) &&
    (!breakdownLocationDetails.locationCode || appointmentSchedulingConfig.locationCodes.includes(breakdownLocationDetails.locationCode))
)
